import { FormCheckBoxModel } from "../../common/types/FormCheckBoxModel";

export const erpNetsisParameters: FormCheckBoxModel[] = [
    {
        value: "1",
        label: "Banka hesabı muhasebe olarak çalışsın mı?",
        formName: "netsisParams.bankToAccountChecked",
        tier: 2
    },
    {
        value: "2",
        label: "Taksit Kırılımında Aktar",
        formName: "netsisParams.isInstallmentRefraction",
        tier: 2
    },
    {
        value: "3",
        label: "Ödeme Fişi Entegrasyonu",
        formName: "paymentsyncCheckbox",
        tier: 1
    },
    {
        value: "4",
        label: "Ödeme Sonrası Otomatik Aktarım",
        formName: "autoPaymentsyncChecked",
        tier: 1
    },
    {
        value: "5",
        label: "Ödeme Aktarımı Döviz Çevrimi Yapılsın Mı?",
        formName: "netsisParams.isexchangeon",
        tier: 1
    },
    {
        value: "6",
        label: "Müşteri Kartı Entegrasyonu",
        formName: "customersyncChecked",
        tier: 1
    },
    {
        value: "7",
        label: "Müşteri Bakiye Entegrasyonu",
        formName: "customerbalanceChecked",
        tier: 1
    },
    {
        value: "8",
        label: "Durum",
        formName: "status",
        tier: 1
    },
    {
        value: "9",
        label: "isCustomerProjectCode",
        formName: "netsisParams.isCustomerProjectCode",
        tier: 1
    },
    {
        value: "10",
        label: "IsCustomerSalesmanCode",
        formName: "netsisParams.isCustomerSalesmanCode",
        tier: 1
    },
];